//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    const pulldownDefaultConfig = {
        content: '下拉刷新',
        height: 40,
        autoRefresh: false,
        downContent: '下拉刷新',
        upContent: '释放后刷新',
        loadingContent: '正在刷新...',
        clsPrefix: 'xs-plugin-pulldown-'
    }
    const pullupDefaultConfig = {
        content: '上拉加载更多',
        pullUpHeight: 60,
        height: 40,
        autoRefresh: false,
        downContent: '释放后加载',
        upContent: '上拉加载更多',
        loadingContent: '加载中...',
        clsPrefix: 'xs-plugin-pullup-'
    }
    export default {
        name: "baby_medication_list",
        data(){
            return{
                keyword: '',
                page: '1',
                listData: [],
                pullupDefaultConfig: pullupDefaultConfig,
                pulldownDefaultConfig: pulldownDefaultConfig,
                showDialog:false,
                group:{
                    drug_name: '',
                    dosage: '',
                    date: '',
                    remark: ''
                }
            }
        },
        methods:{
            //添加记录打开dialog
            addRecord(){
                this.showDialog = true
            },
            //添加记录确认
            dialog_confirm(){
                if(this.group.drug_name == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请输入药品名称',
                    })
                    return
                }
                if(this.group.dosage == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请输入使用剂量',
                    })
                    return
                }
                let re = /^[0-9]+.?[0-9]*/
                if(!re.test(this.group.dosage)){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请输入正确格式',
                    })
                    return
                }
                if(this.group.date == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请选择服药时间',
                    })
                    return
                }
                let params = {
                    token:this.$cookie.get('token'),
                    child_id:this.$route.query.child_id,
                    drug_name:this.group.drug_name,
                    dosage:this.group.dosage,
                    date:this.group.date,
                    remark:this.group.remark,
                }
                Api.babyLiveApi.addBabeMedicationList(params).then ( res => {
                    if(res.errcode == 1){
                        this.$vux.toast.show({
                            type: 'success',
                            text: res.errinfo,
                        })
                        this.showDialog = false
                        this.refresh()
                        this.group.drug_name = ''
                        this.group.dosage = ''
                        this.group.date = ''
                        this.group.remark = ''
                    }else{
                       this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        }) 
                    }
                })
            },
            //dialog隐藏
            dialog_exit(){
                this.showDialog = false
            },
            //时间戳转日期格式    
            formatDateTime(inputTime) {  
                var date = new Date(parseInt(inputTime)*1000)
                var y = date.getFullYear() 
                var m = date.getMonth() + 1  
                m = m < 10 ? ('0' + m) : m; 
                var d = date.getDate()
                d = d < 10 ? ('0' + d) : d
                var h = date.getHours()
                h = h < 10 ? ('0' + h) : h
                var minute = date.getMinutes()
                var second = date.getSeconds()
                minute = minute < 10 ? ('0' + minute) : minute 
                second = second < 10 ? ('0' + second) : second
                return y + '年' + m + '月' + d + '日' + h + ':' + minute + ':' + second
            },
            //清楚筛选
            clearSearch(){
                this.keyword = ''
                this.refresh()
            },
            //筛选
            searchBtn(){
                this.$nextTick(() => {
                    this.$refs.scrollerBottom.reset({top: 0})
                    this.refresh()
                })
            },
            //请求列表数据
            apiCheckRoomRecord(str){
                let params = {
                    token: this.$cookie.get('token'),
                    child_id: this.$route.query.child_id,
                    query: this.keyword,
                    page: this.page
                }
                Api.babyLiveApi.getBabeMedicationList(params).then ( res => {
                    console.info(res)
                    if(res.errcode == 1){
                        this.page++
                        this.$nextTick(() => {
                            this.$refs.scrollerBottom.reset()
                        })
                        if(res.data.list.length){
                            for(let item of res.data.list){
                                let obj = {
                                    user_name: item.user_name,
                                    drug_name: item.drug_name,
                                    child_id: item.child_id,
                                    dosage: item.dosage,
                                    date: item.date,
                                    remark: item.remark
                                }
                                this.listData.push(obj)
                            }
                            this.$refs.scrollerBottom.donePullup()
                            if(str == 'refresh'){
                                this.$refs.scrollerBottom.enablePullup()
                                this.$refs.scrollerBottom.donePulldown()
                            }
                            if( this.page > res.data.page.page_count){
                                // 禁用上拉加载，在没有更多数据时执行
                                this.$refs.scrollerBottom.disablePullup()
                            }
                        }
                    }else{
                        this.listData = []
                        this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        })
                    }
                })
            },
            //下拉刷新
            refresh() {
                this.listData.length = 0
                this.page = '1'
                this.apiCheckRoomRecord('refresh')
            },
            //上拉加载
            loadMore() {
                this.apiCheckRoomRecord()
            },
            goBack(){
                this.$router.push({
                    path: './maternal_service',
                    query: {
                    tabVal: this.$route.query.tabVal,
                    id: this.$route.query.id
                    }
                })
            }
        },
        mounted (){
            this.$nextTick(() => {
                this.$refs.scrollerBottom.reset({top: 0})
            })
            this.apiCheckRoomRecord()
        }
    }



// WEBPACK FOOTER //
// ./src/components/baby_medication_list.vue